import { render, staticRenderFns } from "./InvoicingInformations.vue?vue&type=template&id=048cc0ca&"
import script from "./InvoicingInformations.vue?vue&type=script&lang=js&"
export * from "./InvoicingInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports